import { freddyTheme } from '@coolblue-development/freddy';
import { AvailabilityStates } from '@coolblue-development/next-availability-state';
import { AvailabilityState } from '@features/product/typings';
import { ConfiguratorFragment } from '@features/product-page/api/fragments/configurator';

const DISABLED_CONFIGURATOR_SUB_PRODUCT_TYPES = [
  2207, 15553, 1972, 1970, 3708, 147, 2464, 2204, 2307, 2205, 4270, 4271, 3643, 3646, 3632, 17613,
  15552, 4236, 2419, 3606, 3590, 2462, 17148, 3426, 2163, 2162, 2468, 2329, 17311, 16527, 406, 1971,
  3926, 2276, 15190, 2330, 4321, 16607, 2138, 2137, 2378, 2416, 2362, 2410, 2377, 1287
];

export const isInRemoveConfiguratorSplitTest = (
  isInSplitTest: boolean,
  subProductTypeId?: number | null
) => {
  return isExcludedSubProductType(subProductTypeId) && isInSplitTest;
};

export const shouldTrackRemoveConfiguratorSplitTest = (
  isInSplitTest: boolean,
  subProductTypeId?: number | null
) => {
  return isExcludedSubProductType(subProductTypeId) && !isInSplitTest;
};

function isExcludedSubProductType(subProductTypeId?: number | null) {
  return !!(subProductTypeId && DISABLED_CONFIGURATOR_SUB_PRODUCT_TYPES.includes(subProductTypeId));
}

export function shouldShowConfigurator(
  configurator: ConfiguratorFragment['configurator'],
  availabilityState: AvailabilityState
): boolean {
  if (!configurator) {
    return false;
  }

  return (
    (availabilityState === AvailabilityStates.OnStock ||
      availabilityState === AvailabilityStates.PreOrder) &&
    hasSlots(configurator)
  );
}

function hasSlots(configurator: NonNullable<ConfiguratorFragment['configurator']>): boolean {
  return (
    (configurator?.useCases ?? [])
      .flatMap(useCase => useCase?.slots ?? null)
      .filter(slot => slot !== null).length > 0
  );
}

export function getToggledValue(
  checkboxValues: string[],
  updatedCheckboxValues: string[]
): string | undefined {
  const addedValue = updatedCheckboxValues.find(v => !checkboxValues.includes(v));
  const removedValue = checkboxValues.find(v => !updatedCheckboxValues.includes(v));
  return addedValue ?? removedValue;
}

export const getSelectableCheckboxStyles = (numberOfRows: number) => ({
  '&&': {
    backgroundColor: 'unset',
    boxShadow: `inset 0 0 0 ${freddyTheme.borderWidth[25]} ${freddyTheme.color.background.interactiveControlContrastBase}`,
    width: '100%'
  },

  [freddyTheme.breakpoint.minWidth('md')]: {
    '& > div:last-child': {
      display: 'grid',
      gridTemplateRows: 'subgrid',
      gridRow: `span ${numberOfRows}`,
      marginLeft: 0,
      gap: freddyTheme.spacing[200]
    }
  }
});
